import { createSelector } from '@ngrx/store';
import { AppState } from 'src/app/store/app.states';
import { IMobileVerificationState } from './state';

const state = (state: AppState) => state.mobileVerificationState;

export const mobileVerification_Form = createSelector(
  state,
  (state: IMobileVerificationState) => state.form
);

export const mobileVerification_IsMobileVerified = createSelector(
  state,
  (state: IMobileVerificationState) => state.form.value.isMobileVerified
);

export const mobileVerification_SendMobileCodeMessage = createSelector(
  state,
  (state: IMobileVerificationState) => state.message
);

export const mobileVerification_DataSaved = createSelector(
  state,
  (state: IMobileVerificationState) => state.dataSaved
);